<!-- Loader -->
@if (loading$ | async; as loading) {
    @if (loading) {
        <app-loader></app-loader>
    }
}

@if (installations$ | async; as installations) {
    @if (installations && !isInToolbar) {
        <h2 class="title header-large mt-large mb-large" translate="userProfile.title"></h2>
        <!-- Customer relations -->
        <app-customer-relations
            class="flex flex-col mb-30px"
            [installations]="installations"
            [isInToolbar]="isInToolbar"
            [showSummary]="isInToolbar"
            [dark]="true"
            (selectInstallation)="onSelectInstallation($event)"
            (addCustomerRelation)="onAddCustomerRelation()"
        >
        </app-customer-relations>
        <!-- Associated users -->
        @if (customerNumber$ | async; as customerNumber) {
            @if (associatedUsers$ | async; as associatedUsers) {
                <app-private-associated-users
                    class="space"
                    [customerNumber]="customerNumber"
                    [associatedUsers]="associatedUsers"
                >
                </app-private-associated-users>
            }
        }
        <!-- Payment details -->
        @if (paymentDetails$ | async; as paymentDetails) {
            <app-private-payment-details
                class="space"
                [paymentDetails]="paymentDetails"
                [supplierName]="supplierName$ | async"
                (subscribe)="onSubscribeTo($event)"
                (unsubscribe)="onUnsubscribeFrom($event)"
            >
            </app-private-payment-details>
        }
        <!-- Installations -->
        @if (installationDetails$ | async; as installationDetails) {
            <app-installations [installationDetails]="installationDetails"></app-installations>
        }
    }
    @if (installations && isInToolbar) {
        <app-customer-relations
            class="flex flex-col"
            [installations]="installations"
            [isInToolbar]="isInToolbar"
            (selectInstallation)="onSelectInstallation($event)"
            (addCustomerRelation)="onAddCustomerRelation()"
        >
        </app-customer-relations>
    }
}
